import type { FC } from 'react';
import type { FaqDto } from '@/queries/system-pages';
import { useTranslations } from 'next-intl';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './accordion';

interface FaqAccordionSectionProps {
  className?: string;
  faqsList?: FaqDto[];
}

export const FaqAccordionSection: FC<FaqAccordionSectionProps> = ({ className, faqsList }) => {
  const t = useTranslations('common');

  if (!faqsList || faqsList.length === 0) {
    return null;
  }

  return (
    <section className={className}>
      <h3 className="mb-4 text-xl leading-[1.4] font-medium text-light">{t('faq')}</h3>

      {
        faqsList.map((item, index) => (
          <Accordion type="single" collapsible className="w-full" key={index}>
            <AccordionItem value={`item-${index + 1}`} className="box-border border-y border-light/10">

              <AccordionTrigger className="text-primary-3 text-lg -mt-px tracking-normal leading-7 pr-3.5">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-light text-base leading-6 mb-6.5 md:mt-3 mt-4.5 md:mb-4.5">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        ))
      }
    </section>
  );
};
